import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class VrpService {
  /**
   * Driving route through points, in order.
   * @param {Array<[number, number]>} points [[lat, lng], ...]
   * @returns {Promise<{distance_km:number, duration_min:number, polyline:Array<[number, number]>}|null>}
   *          null when the routing service is unavailable.
   */
  getRoute(points) {
    return axios
      .post(`${config["apiUrl"]}vrp/route`, { points }, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  routesSuggestions(params) {
    return axios
      .post(`${config["apiUrl"]}vrp/routing-suggestion`, params, {
        headers: authHeader()
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }
}

export default new VrpService();
